<template>
  <v-app>
    <NotificationContainer />
    <NavBar :user="getUser" v-if="getUser" />
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import NotificationContainer from "@/components/notifications/NotificationContainer.vue";
import { mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import store from "./store";
import { db } from "./firebase";

export default {
  name: "App",
  components: { NavBar, NotificationContainer },
  data: () => ({}),
  computed: {
    ...mapGetters(["getUser"])
  }
};
</script>
